import React, { memo } from "react";
import PropTypes from "prop-types";

const Legend = ({ items }) => {
  return (
    <div className="insights-legends">
      {items.map((item) => {
        return (
          <div key={item.title} className="insights-legend">
            <span style={{ backgroundColor: item.color }}></span>
            {item.title}
          </div>
        );
      })}
    </div>
  );
};

Legend.propTypes = {
  items: PropTypes.array,
};

export default memo(Legend);
